import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get values() {
    return {
      domain: String,
      limit: Number,
      offset: Number,
      type: String,
      department: String,
      requiredField: String,
    }
  }

  connect() {
    let nextUrl = App.api.domainSearch({
      domain: this.domainValue,
      limit: this.limitValue,
      offset: this.offsetValue,
      type: this.typeValue,
      department: this.departmentValue,
      requiredField: this.requiredFieldValue,
      format: "turbo_stream",
    })

    $(this.element).parent().attr("action", nextUrl)
    $(this.element).delay(500).fadeIn()
    this.element.addEventListener("click", () => {
      $(this.element).text("Loading...")
      App.analytics.ga_track("Domain Search", `Show more (${this.offsetValue})`)
    })
  }
}
